<template>
  <div class="main-banner-area">
    <div >
      <carousel :dir="direction" :autoplay="5000" :settings="settings" :wrap-around="true" :breakpoints="breakpoints" key="">

        <slide v-for="slide of BannerImages" :key="slide.uuid">    
           <img :src="slide.url" class="w-100"> 
        </slide>

        <!-- <slide  key="2">
          <div :class="slide.class">
            <div class="d-table">
              <div class="d-table-cell swiper-slide">
                <div class="container">
                  <div class="row d-flex justify-content-xl-between align-items-center">
                   <img src="../../assets/images/3-courses-package.jpg" class="w-100">
                    <div class="col-xl-8 col-lg-7 order-lg-1 order-2">
                      <div class="mainSlider__content">
                        <h1 class="mainSlider__title text-white">
                          {{ $t('mainSlider.title') }} <br />
                          <span class="text-green-1">{{ $t('mainSlider.subtitle') }}</span>
                        </h1>

                        <div class="mainSlider__form">
                          <div class="d-flex gap-3">
                            <router-link to="/courses" class="d-inline-flex justify-center align-items-center gap-2"
                              aria-label="explore">
                              <span> {{ $t("button2") }} </span>
                              <span class="rotate-svg">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                  fill="none">
                                  <path
                                    d="M15.586 10.657L11.636 6.70704C11.4538 6.51844 11.353 6.26584 11.3553 6.00364C11.3576 5.74144 11.4628 5.49063 11.6482 5.30522C11.8336 5.11981 12.0844 5.01465 12.3466 5.01237C12.6088 5.01009 12.8614 5.11088 13.05 5.29304L18.707 10.95C18.8002 11.0427 18.8741 11.1529 18.9246 11.2742C18.9751 11.3955 19.001 11.5256 19.001 11.657C19.001 11.7884 18.9751 11.9186 18.9246 12.0399C18.8741 12.1612 18.8002 12.2714 18.707 12.364L13.05 18.021C12.9578 18.1166 12.8474 18.1927 12.7254 18.2451C12.6034 18.2976 12.4722 18.3251 12.3394 18.3263C12.2066 18.3274 12.0749 18.3021 11.952 18.2519C11.8291 18.2016 11.7175 18.1273 11.6236 18.0334C11.5297 17.9395 11.4555 17.8279 11.4052 17.705C11.3549 17.5821 11.3296 17.4504 11.3307 17.3176C11.3319 17.1849 11.3595 17.0536 11.4119 16.9316C11.4643 16.8096 11.5405 16.6993 11.636 16.607L15.586 12.657H6C5.73478 12.657 5.48043 12.5517 5.29289 12.3641C5.10536 12.1766 5 11.9223 5 11.657C5 11.3918 5.10536 11.1375 5.29289 10.9499C5.48043 10.7624 5.73478 10.657 6 10.657H15.586Z"
                                    fill="white" />
                                </svg>
                              </span>
                            </router-link>

                            <a href="#popularCategories" class="d-inline-flex justify-center align-items-center gap-2"
                              aria-label="popular">
                              <span> {{ $t("button3") }} </span>
                              <span class="rotate-svg">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                  fill="none">
                                  <path
                                    d="M15.586 10.657L11.636 6.70704C11.4538 6.51844 11.353 6.26584 11.3553 6.00364C11.3576 5.74144 11.4628 5.49063 11.6482 5.30522C11.8336 5.11981 12.0844 5.01465 12.3466 5.01237C12.6088 5.01009 12.8614 5.11088 13.05 5.29304L18.707 10.95C18.8002 11.0427 18.8741 11.1529 18.9246 11.2742C18.9751 11.3955 19.001 11.5256 19.001 11.657C19.001 11.7884 18.9751 11.9186 18.9246 12.0399C18.8741 12.1612 18.8002 12.2714 18.707 12.364L13.05 18.021C12.9578 18.1166 12.8474 18.1927 12.7254 18.2451C12.6034 18.2976 12.4722 18.3251 12.3394 18.3263C12.2066 18.3274 12.0749 18.3021 11.952 18.2519C11.8291 18.2016 11.7175 18.1273 11.6236 18.0334C11.5297 17.9395 11.4555 17.8279 11.4052 17.705C11.3549 17.5821 11.3296 17.4504 11.3307 17.3176C11.3319 17.1849 11.3595 17.0536 11.4119 16.9316C11.4643 16.8096 11.5405 16.6993 11.636 16.607L15.586 12.657H6C5.73478 12.657 5.48043 12.5517 5.29289 12.3641C5.10536 12.1766 5 11.9223 5 11.657C5 11.3918 5.10536 11.1375 5.29289 10.9499C5.48043 10.7624 5.73478 10.657 6 10.657H15.586Z"
                                    fill="white" />
                                </svg>
                              </span>
                            </a>

                          </div>
                        </div>
                      </div>
                    </div>
                    end of first column--
                    ---Start of second column-------
                    <div class="col-xl-4 col-lg-5 order-1 order-lg-2">
                      <div
                        class="mainSlider__content mainSlider__content-img d-flex justify-content-center align-items-center">
                        <div class="mainSlider__image--outer-3">
                          <div class="mainSlider__image--outer-2">
                         
                            <div class="mainSlider__image--outer-1">
                              <div class="mainSlider__image">
                                <img src="../../assets/images/home/banner-1.png" class="img-fluid" alt="outer image" />

                                ----play Button-----
                                <span class="play-btn" data-bs-toggle="modal" data-bs-target="#exampleModal">
                                  <div class="absolute-full-center d-flex justify-center items-center">
                                    <div class="text-18">
                                      <svg xmlns="http://www.w3.org/2000/svg" width="88" height="88" viewBox="0 0 88 88"
                                        fill="none">
                                        <path
                                          d="M44 7.33325C36.748 7.33325 29.6589 9.48371 23.6291 13.5127C17.5993 17.5417 12.8996 23.2682 10.1244 29.9682C7.3492 36.6681 6.62308 44.0406 8.03787 51.1532C9.45266 58.2659 12.9448 64.7992 18.0728 69.9272C23.2007 75.0551 29.7341 78.5473 36.8467 79.962C43.9593 81.3768 51.3318 80.6507 58.0317 77.8755C64.7317 75.1003 70.4582 70.4006 74.4872 64.3708C78.5162 58.341 80.6667 51.2519 80.6667 43.9999C80.6667 39.1848 79.7183 34.4168 77.8756 29.9682C76.0329 25.5196 73.3321 21.4775 69.9272 18.0727C66.5224 14.6679 62.4803 11.967 58.0317 10.1243C53.5831 8.28166 48.8151 7.33325 44 7.33325ZM36.6667 60.4999V27.4999L58.6667 43.9999L36.6667 60.4999Z"
                                          fill="#062B3B" />
                                      </svg>
                                    </div>
                                  </div>
                                </span>
                              </div>
                              
                            </div> 
                            ---------outer 1-------
                          !-- </div> --
                          !---------outer 2--
                        !-- </div> --
                        !------------outer-3--
                        !-------------
                      !-- </div> --
                    !-- </div> --
                  --end of secound column---------
                  -- </div>
                </div> --
              -- </div>
            </div> --
          !-- </div> --
        </slide> -->

        <template #addons>
          <navigation>
            <template #next>
              <button class="banner-navigation rotate-svg" aria-label="next button">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" xmlns="http://www.w3.org/2000/svg" width="24"
                  height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m9 5 7 7-7 7" />
                </svg>
              </button>
            </template>
            <template #prev>
              <button class="banner-navigation rotate-svg" aria-label="previuos button ">
                <svg class="w-6 h-6 text-gray-800 dark:text-white" xmlns="http://www.w3.org/2000/svg" width="24"
                  height="24" fill="none" viewBox="0 0 24 24">
                  <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                    d="m15 19-7-7 7-7" />
                </svg>
              </button>
            </template>
          </navigation>
        </template>
      </carousel>
    </div>
  </div>


  <div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true"
    ref="modal">
    <div class="modal-dialog modal-dialog-centered" @click="handleOutsideClick">
      <div class="modal-content">
        <div class="modal-header">
          <button type="button" data-bs-dismiss="modal" aria-label="Close">
            <svg class="w-6 h-6 text-gray-800 dark:text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg"
              width="24" height="24" fill="none" viewBox="0 0 24 24">
              <path stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                d="M6 18 17.94 6M18 18 6.06 6" />
            </svg>
          </button>
        </div>
        <div class="modal-body" @click.stop>
          <video ref="video" class="w-100" controls>
            <source src="" type="video/mp4" />
            <!----<source :src="heroVideo" type="video/mp4">-->
            Your browser does not support the video tag.
          </video>
        </div>
        <!----<div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Close</button>
        <button type="button" class="btn btn-primary">Save changes</button>
      </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from "vue";
import { Carousel, Navigation, Pagination, Slide } from "vue3-carousel";
import "vue3-carousel/dist/carousel.css";
import { mapGetters } from "vuex";
export default defineComponent({
  name: "Banner",
  components: {
    Carousel,
    Slide,
    Pagination,
    Navigation,
  },

  data: () => ({
    video: null,
    modal: null,
    direction: localStorage.getItem("direction") || "ltr",
    carouselItems: [],
    settings: {
      itemsToShow: 1,
      snapAlign: "center",
    },
  }),
  computed: {
    ...mapGetters(["currentLanguage"]),
    BannerImages (){
      return this.$store.getters.getSettings.coverImages
    }
  },
  methods: {
    addPadding(){
      this.$store.commit('setPaddingAdd',true)
    },
    handleOutsideClick(event) {
      // Check if the click was outside the video
      if (this.video && !this.video.contains(event.target)) {
        this.video.pause();
        this.video.currentTime = 0; // Optionally reset the video
      }
    },
  },
  mounted() {
    // Assign refs after mounting
    this.video = this.$refs.video;
    this.modal = this.$refs.modal;

    // Add Bootstrap modal event listener
    if (this.modal) {
      this.modal.addEventListener("hidden.bs.modal", () => {
        if (this.video) {
          this.video.pause();
          this.video.currentTime = 0; // Optionally reset the video
        }
      });
    }
  },
  beforeDestroy() {
    // Clean up event listener
    if (this.modal) {
      this.modal.removeEventListener("hidden.bs.modal", this.handleOutsideClick);
    }
  },
  watch: {
    currentLanguage: {
      handler(newval) {
        if (newval === "en") {
          this.direction = "ltr";
        } else {
          this.direction = "rtl";
        }
      },
      immediate: true,
    },
  },
});
</script>
<style lang="scss" scoped>
.modal-dialog {
  max-width: 60%;
}

.modal-content {
  background: #fff;
  border: 0;
}

.modal-header {
  border-bottom: 0;
  padding: 0px 15px;
  padding-top: 20px;

  button {
    background: #09445d;
    padding: 4px;
    border-radius: 5px;
  }
}

.carousel__slide {
 // height: 550px;

  &:lang(en) {
    text-align: left;
  }

  &:lang(ar) {
    text-align: right;
  }
}

/********Main sider Styling**************************/
// .main-banner-area {
//  background-image: url(../../assets/images/home/bannerNew.jpg);
//   background-size: cover;
//   background-repeat: no-repeat;
//   background-position: center center;
//   width: 100%;
//  height: 700px;
//   position: relative;
//   z-index: 0;
//    margin-bottom: 100px;
// }

// .mainSlider.-type-1 .swiper-wrapper {
//   position: absolute;
//   z-index: -1;
//   top: 0;
//   left: 0;
//   width: 100%;
//   height: 100%;
// }

// .mainSlider.-type-1 .swiper-slide {
//   z-index: 1;
//   position: relative;
//   padding-top: 20px;
//   padding-bottom: 34px;
// }

.mainSlider.-type-1 .swiper-prev,
.mainSlider.-type-1 .swiper-next {
  border-radius: 8px;
  background: rgba(255, 255, 255, 0.2);
  -webkit-box-shadow: -4px 4px 20px 0px rgba(1, 40, 56, 0.1);
  box-shadow: -4px 4px 20px 0px rgba(1, 40, 56, 0.1);
  padding: 20px;
  gap: 10px;
  -webkit-transition: 0.2s ease-in-out;
  -o-transition: 0.2s ease-in-out;
  transition: 0.2s ease-in-out;
}

.mainSlider.-type-1 .swiper-prev:hover,
.mainSlider.-type-1 .swiper-next:hover {
  cursor: pointer;
  background: rgba(255, 255, 255, 0.8);
}

.mainSlider.-type-1 .swiper-prev {
  z-index: 2;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  left: 60px;
}

.mainSlider.-type-1 .swiper-next {
  z-index: 2;
  position: absolute;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  right: 60px;
}

// .main-banner-area .mainSlider__content {
//   padding-top: 100px;
//   height: -webkit-fit-content;
//   height: -moz-fit-content;
//   height: fit-content;
// }

// .main-banner-area .mainSlider__title {
//   font-size: 60px;
//   font-weight: 700;
//   line-height: 130%;
//   font-family: var(--font-family-1);
// }

// .main-banner-area .mainSlider__text {
//   font-size: 17px;
//   line-height: 36px;
//   margin-top: 13px;
// }


// .main-banner-area .mainSlider__form div a {
//   color: var(--color-white) !important;
//   font-family: var(--font-family-1);
//   font-size: 20px;
//   font-style: normal;
//   font-weight: 500;
//   line-height: 140%;
//   padding: 16px;
//   -webkit-transition: 0.2s ease-in-out;
//   -o-transition: 0.2s ease-in-out;
//   transition: 0.2s ease-in-out;
//   cursor: pointer !important;
// }

// .main-banner-area .mainSlider__form div a:hover {
//   -webkit-transform: translateX(5px) !important;
//   -ms-transform: translateX(5px) !important;
//   transform: translateX(5px) !important;
//   opacity: 0.8;
// }

// .main-banner-area .mainSlider__form div a:hover:lang(ar) {
//   -webkit-transform: translateX(-5px) !important;
//   -ms-transform: translateX(-5px) !important;
//   transform: translateX(-5px) !important;
// }

// .main-banner-area .mainSlider__form div a:nth-of-type(1) {
//   border-radius: 8px;
//   background: var(--secondary-color);
// }

// .main-banner-area .mainSlider__image {
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: center;
//   -ms-flex-pack: center;
//   justify-content: center;
//   -webkit-box-align: center;
//   -ms-flex-align: center;
//   align-items: center;
//   border-radius: 50%;
//   position: relative;
//   z-index: 2;
//   width: 316px;
//   height: 316px;
//   background-color: var(--secondary-color);
//   padding: 27px;
//   border: none;
// }

// .mainSlider__image .play-btn {
//   display: inline-block;
//   position: absolute;
//   top: 50%;
//   left: 50%;
//   -webkit-transform: translate(-50%, -50%);
//   -ms-transform: translate(-50%, -50%);
//   transform: translate(-50%, -50%);
//   cursor: pointer;
// }

// .mainSlider__image--outer-1,
// .mainSlider__image--outer-2,
// .mainSlider__image--outer-3 {
//   display: -webkit-box;
//   display: -ms-flexbox;
//   display: flex;
//   -webkit-box-pack: center;
//   -ms-flex-pack: center;
//   justify-content: center;
//   -webkit-box-align: center;
//   -ms-flex-align: center;
//   align-items: center;
//   border-radius: 50%;
//   position: relative;
//   width: -webkit-fit-content;
//   width: -moz-fit-content;
//   width: fit-content;
//   height: -webkit-fit-content;
//   height: -moz-fit-content;
//   height: fit-content;
// }

// .mainSlider__image--outer-2::before,
// .mainSlider__image--outer-1::before,
// .mainSlider__image--outer-3::before {
//   content: "";
//   position: absolute;
//   background: #d6d6d6;
//   border-radius: 50%;
// }

// .mainSlider__image--outer-1::before {
//   z-index: -1;
//   width: 354px;
//   height: 354px;
//   -webkit-animation: pulse 5s linear infinite;
//   animation: pulse 5s linear infinite;
//   -webkit-animation-delay: -7s;
//   animation-delay: -7s;
// }

// .mainSlider__image--outer-2::before {
//   z-index: -1;
//   width: 380px;
//   height: 380px;
//   -webkit-animation: pulse 5s linear infinite;
//   animation: pulse 5s linear infinite;
//   -webkit-animation-delay: -5s;
//   animation-delay: -5s;
// }

// .mainSlider__image--outer-3::before {
//   z-index: -1;
//   width: 402px;
//   height: 402px;
//   -webkit-animation: pulse 5s ease-in-out infinite;
//   animation: pulse 5s ease-in-out infinite;
//   -webkit-animation-delay: -2s;
//   animation-delay: -2s;
// }

.mainSlider__image img {
  width: 100%;
  height: 100%;
  -o-object-fit: cover;
  object-fit: cover;
  border-radius: 50%;
}

/* Pulse animation */
@-webkit-keyframes pulse {
  0% {
    -webkit-transform: scale(0.6);
    transform: scale(0.6);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1.08);
    transform: scale(1.08);
    opacity: 0;
  }
}

@keyframes pulse {
  0% {
    -webkit-transform: scale(0.6);
    transform: scale(0.6);
    opacity: 1;
  }

  100% {
    -webkit-transform: scale(1.08);
    transform: scale(1.08);
    opacity: 0;
  }
}

@media (max-width: 767.9px) {
  // .main-banner-area {
  //  height: 800px;
  // }

  // .carousel__slide {
  //  height: 760px;
  // }

  .main-banner-area .swiper-slide {
    padding-top: 52px;
    padding-bottom: 50px;
  }

  .mainSlider.-type-1 .swiper-prev {
    display: none !important;
  }

  .mainSlider.-type-1 .swiper-next {
    display: none !important;
  }

  .main-banner-area .mainSlider__title {
    font-size: 35px;
  }

  .modal-dialog {
    max-width: 90%;
  }
}

@media screen and (min-width: 768px) and (max-width: 992px) {
  // .main-banner-area {
  //   height: 80vh;
  // }

  .modal-dialog {
    max-width: 80%;
  }

  // .carousel__slide {
  //   height: 850px;
  // }

  // .main-banner-area .mainSlider__content {
  //   padding-top: 80px;
  //   padding-bottom: 0px;
  //   height: -webkit-fit-content;
  //   height: -moz-fit-content;
  //   height: fit-content;
  // }

  // .main-banner-area .swiper-slide {
  //   padding-top: 80px;
  //   padding-bottom: 0px;
  // }
}

@media screen and (max-width: 992px) {
  // .main-banner-area .mainSlider__content {
  //   padding-top: 30px;
  //   padding-bottom: 0px;
  //   height: -webkit-fit-content;
  //   height: -moz-fit-content;
  //   height: fit-content;
  // }

  // .main-banner-area .swiper-slide {
  //   padding-top: 80px;
  //   padding-bottom: 0px;
  // }

  // .main-banner-area .mainSlider__text {
  //   margin-top: 15px;
  //   font-size: 16px;
  //   line-height: 1.6;
  // }

  // .main-banner-area .mainSlider__title {
  //   font-size: 45px;
  //   line-height: 1.3;
  // }

  // .main-banner-area .mainSlider__form div a {
  //   font-size: 14px !important;
  // }

  // .mainSlider__content {
  //   display: -webkit-box;
  //   display: -ms-flexbox;
  //   display: flex;
  //   -webkit-box-orient: vertical;
  //   -webkit-box-direction: normal;
  //   -ms-flex-direction: column;
  //   flex-direction: column;
  //   text-align: center;
  //   -webkit-box-align: center;
  //   -ms-flex-align: center;
  //   align-items: center;
  // }
}

@media screen and (max-width: 500px) {
  .main-banner-area .mainSlider__content {
    padding-top: 17px;
  }

  // .mainSlider__content-img .mainSlider__image {
  //   width: 222px;
  //   height: 222px;
  // }

  // .mainSlider__image--outer-1::before {
  //   width: 240px;
  //   height: 240px;
  // }

  // .mainSlider__image--outer-2::before {
  //   width: 260px;
  //   height: 260px;
  // }

  // .mainSlider__image--outer-3::before {
  //   width: 280px;
  //   height: 280px;
  // }

  .main-banner-area .mainSlider__title {
    font-size: 30px;
  }
}

@media screen and (min-width: 370.8px) and (max-width: 570px) {
  .main-banner-area .mainSlider__content {
    padding-top: 17px;
  }

  // .main-banner-area {
  //   height: 700px;
  // }

  // .mainSlider__content-img .mainSlider__image {
  //   width: 210px;
  //   height: 210px;
  // }

  // .mainSlider__image--outer-1::before {
  //   width: 220px;
  //   height: 220px;
  // }

  // .mainSlider__image--outer-2::before {
  //   width: 240px;
  //   height: 240px;
  // }

  // .mainSlider__image--outer-3::before {
  //   width: 260px;
  //   height: 260px;
  // }

  .main-banner-area .mainSlider__title {
    font-size: 25px;
    padding: 10px 15px;
  }
}

@media screen and (min-width: 992.1px) and (max-width: 1200px) {
  // .main-banner-area .mainSlider__content {
  //   padding-top: 80px;
  //   padding-bottom: 60px;
  //   height: -webkit-fit-content;
  //   height: -moz-fit-content;
  //   height: fit-content;
  // }

  // .main-banner-area .mainSlider__title {
  //   font-size: 50px;
  // }

  // .main-banner-area .mainSlider__text {
  //   margin-top: 15px;
  //   font-size: 16px;
  //   line-height: 1.6;
  // }

  // .main-banner-area .mainSlider__items {
  //   padding-top: 70px;
  // }

  .main-banner-area .swiper-slide {
    padding-top: 80px;
    padding-bottom: 40px;
  }

  .main-banner-area .mainSlider__form div a {
    font-size: 14px !important;
  }

  .main-banner-area .swiper-prev {
    left: 16px;
  }

  .main-banner-area .swiper-prev,
  .main-banner-area .swiper-next {
    padding: 10px;
  }

  .main-banner-area .swiper-next {
    right: 16px;
  }
}

@media screen and (min-width: 1600px) {
  .main-banner-area .mainSlider__items {
    padding-top: 80px;
  }

  // .main-banner-area .mainSlider__content {
  //   padding-top: 120px;
  // }

  // .carousel__slide {
  //   height: 784px;
  // }

  // .main-banner-area .swiper-slide {
  //   padding-top: 105px;
  //   padding-bottom: 40px;
  // }

  // .main-banner-area {
  //   height: 85vh;
  // }

  .main-banner-area .mainSlider__title {
    font-size: 70px;
  }
}
</style>
